import { MEDIA_TYPES } from '@wix/wix-vod-constants/common';
import { ReversedSortOrders } from './video.types';
import { SortDirections, SortOrders, } from '@wix/wix-vod-constants/api-types';
const DEFAULT_PAGING = {
    size: 30,
    cursor: null,
};
const DEFAULT_SORT = {
    order: SortOrders.Custom,
    direction: SortDirections.Ascending,
};
export const mapOptionsToQueryParams = ({ query, tag, category, mediaType = MEDIA_TYPES.SECURE_VIDEO, sort, paging, itemType, templateMetaSiteId, withPlayInfo, }) => {
    const sortWithDefaults = {
        ...DEFAULT_SORT,
        ...sort,
    };
    const pagingWithDefaults = {
        ...DEFAULT_PAGING,
        ...paging,
    };
    const reversedOrderMapping = {
        [SortOrders.Custom]: ReversedSortOrders.ReverseCustom,
        [SortOrders.Name]: ReversedSortOrders.ReverseName,
        [SortOrders.Relevance]: ReversedSortOrders.ReverseRelevance,
        [SortOrders.Date]: ReversedSortOrders.ReverseDate,
    };
    const params = {
        metaSiteId: templateMetaSiteId,
        query,
        tag,
        category,
        media_type: mediaType,
        page_size: pagingWithDefaults.size,
        item_type: itemType,
        cursor: pagingWithDefaults.cursor,
        order: sortWithDefaults.direction === SortDirections.Descending &&
            reversedOrderMapping[sortWithDefaults.order]
            ? reversedOrderMapping[sortWithDefaults.order]
            : sortWithDefaults.order,
    };
    if (withPlayInfo) {
        params.with_play_info = true;
    }
    return params;
};
//# sourceMappingURL=video.utils.js.map